module.exports = __webpack_public_path__ + "img/icon-line-chart-time-active.89d53f36.svg";